module.exports = __webpack_public_path__ + "media/images/game/footer-guy-light-d4878635c9d075deaa5868a36bb51b53.png";